<template>
    <b-container fluid style="padding-top: 10px">
        <vue-good-table
                v-if="true"
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed table-bordered table-striped"
                @on-row-click="onRowClick"
                :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 50,
                    position: 'top',
                    perPageDropdown: [50, 100, 200],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                }">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.label === 'Add To Survey'">
                    <b-button size="sm"
                              @click="assignToSurvey(props.formattedRow[props.column.field])" disabled="true">
                           Assign
                    </b-button>
                </span>
                <span v-else-if="props.column.label === 'Calculator'">
                    <b-button size="sm"
                              @click="goToCalculator(props.formattedRow[props.column.field])">Metrics Summary</b-button>
                </span>
                <span v-else-if="props.column.label === 'Certify'">
                    <b-button size="sm"
                              @click="certify(props.formattedRow['surveyId'], data.item.winery, props.formattedRow['groupId'])">
                    Certify
                    </b-button>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </b-container>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';

export default {
  name: "LoginAdmin",
  components: {
    Datepicker,
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: "Page",
          field: "name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Page Name', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Text",
          field: "text"
        },
        {
          label: "Control Type",
          field: "controlType"
        },
        {
          label: "Creation Date",
          field: "creationDate",
          type: 'date',

          formatFn: value => {
            if (value === "" || value === null) {
              return "Unknown";
            }

            let date = new Date(0);

            date.setUTCMilliseconds(value);

            let options = {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric'
            };
            return date.toLocaleDateString("en-US", options)
          }
        },
        {
          label: "Title",
          field: "title",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Question Text', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Green Note",
          field: "greenNote"
        },
        {
          label: "Add To Survey",
          field: "_id"
        }
      ],
      items: [],
      rows: [],
      certificationDate: '',
      surveyToCertify: '',
      groupIdToCertify: ''
    }
        }, mounted() {
            this.$http.get("measures/")
                .then(result => {
                    this.rows = result.data;
                })
                .catch(error => {
                    console.log("The error: " + error);
                })

        },
        methods: {
            isNotCertifier: function () {
                // return !localStorage.getItem("roles").includes("THIRD_PARTY_CERTIFIER");
            },
            selected(item) {
                /*                console.log("The item: ");
                                console.log(item);
                                localStorage.setItem('adminImpersonationGroupId', item.groupId);
                                this.$router.push({name: 'SurveyLink', params: {surveyKey: item.surveyId, groupId: item.groupId}});//path: '/survey' + item.surveyId});
                            */
            },
            onRowClick(params) {
                /*                console.log("The item: ");
                                console.log(params);*/
            },
            certify: function (surveyIdValue, wineryName, groupId) {
                /*                this.$bvModal.show("modal-1");
                                this.surveyToCertify = surveyIdValue;
                                this.groupIdToCertify = groupId;*/

            },
            goToCalculator: function (group) {
                /*               localStorage.setItem('adminImpersonationGroupId', group);
                               this.$router.push({name: "TabbedMetrics", params: {groupId: group}})
                                   .catch(err => {
                                   });*/
            },
            assignToSurvey: function (groupId) {
                this.$toasted.show(`Assign Question: id : ${groupId}`,
                    {
                        containerClass: 'super-toasty',
                        iconPack: 'fontawesome',
                        closeOnSwipe: true,
                        action: {
                            text: 'DISMISS',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                        icon: {
                            name: 'fa-check-circle',
                            after: false,
                        }
                    })
                    .goAway(5000);
            },
            /*            dismissTheModal: function () {
                            this.$bvModal.hide("modal-1");
                            this.surveyToCertify = '';
                            this.groupIdToCertify = '';
                            this.certificationDate = '';*/
        },
        saveAction: function () {
            /*               this.$bvModal.hide("modal-1");
                           let certRequest = {
                               certificationDate: new Date(this.certificationDate),
                               surveyResponseId: this.surveyToCertify,
                               certifierId: localStorage.getItem('user'),
                               groupId: this.groupIdToCertify
                           }

                           let inviteRequestJson = JSON.stringify(certRequest, null, 3);
                           this.$http.post("survey/certify", inviteRequestJson
                               , {
                                   headers: {
                                       'content-type': 'application/json'
                                   }
                               })
                               .then(response => {
                                   console.log(response);
                                   alert(response.data);
                                   swal({
                                       title: "Group has been Certified",
                                       type: "success",
                                       timer: 3000
                                   });
                               })
                               .catch(fail => {
                                   swal(" Certification Attempt Failed. [" + fail + "]");
                               });
                       }*/
        }
    }
</script>
